'use client'

import { Calendar, FormControl, FormField, FormItem, FormMessage } from '@repo/ui'
import { startOfTomorrow } from 'date-fns'
import { useMemo } from 'react'
import { useController } from 'react-hook-form'

import { useDateTimeInput } from './context.tsx'

export const CalendarInput = () => {
  const {
    control,
    dateState: [date, setDate],
    index,
    isAdmin,
    quickSelectState: [_quickSelect, setQuickSelect],
    quickSelectUsed,
    timeState: [_time, setTime],
  } = useDateTimeInput()

  const previousStopControl = useController({
    control,
    name: `drops.${index - 1}.date`,
  })

  const disabled = useMemo(
    () =>
      isAdmin
        ? previousStopControl.field.value
          ? {
              before: new Date(previousStopControl.field.value),
            }
          : undefined
        : {
            before: previousStopControl.field.value
              ? new Date(previousStopControl.field.value)
              : startOfTomorrow(),
          },
    [isAdmin],
  )

  return (
    <FormField
      control={control}
      name={`drops.${index}.date`}
      render={() => (
        <FormItem>
          <FormControl>
            <Calendar
              classNames={{
                chevron: 'dark:fill-slate-100',
                selected:
                  process.env.NEXT_PUBLIC_SOURCE === 'cargoking-shipper'
                    ? 'text-white bg-brand'
                    : 'bg-brand-gradient text-white',
                weekday:
                  'text-muted-foreground rounded-md w-9 font-normal text-[0.8rem] text-black',
              }}
              disabled={disabled}
              mode={'single'}
              onSelect={date => {
                setDate(date)
                setQuickSelect(undefined)
                setTime(prev => ({
                  ...prev,
                  type: 'between',
                }))
              }}
              selected={!date || quickSelectUsed ? undefined : date}
              showOutsideDays={false}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
